import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrilliance: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrilliance"><Path d="M12 2.5C9.23858 2.5 7 4.62665 7 7.25C7 13.7942 17 10.2058 17 16.75C17 19.3734 14.7614 21.5 12 21.5M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBrilliance;
